// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
function CustomerSelectionModal({ show, onClose, customers, onSelectCustomer, stockCategoryList, DiscountsList, CategoryID }) {
    debugger;
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [selectedCustomers, setSelectedCustomers] = useState([]);

    const tableRef = useRef();
    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const [formData, setFormData] = useState({ PK_ClientCompanyCategory_ID: 0, FK_StockCategory_ID: CategoryID, FK_DiscountType_ID: 0, dec_Amount: 0 });
    const handleCheckboxChange = (customer) => {
        setSelectedCustomers((prev) => {
            const exists = prev.some(
                c => c.ClientCompanyID === customer.ClientCompanyID
            );

            if (exists) {
                return prev.filter(
                    c => c.ClientCompanyID !== customer.ClientCompanyID
                );
            }

            return [...prev, customer];
        });
    };

    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (customers && customers.length > 0) {
            console.log('Company list updated, initializing DataTable with data:', customers);
            initDataTable();
        }
    }, [customers]);
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleRowClick = (event, part) => {
        if (formData.FK_StockCategory_ID > 0 && formData.FK_DiscountType_ID) {
            onSelectCustomer(event, part, formData);
            onClose();
        }
        else {
            Swal.fire(
                'Error!',
                'Please select discount type first.',
                'error'
            );
        }
    };
    const handleSubmit = async () => {

        if (selectedCustomers.length === 0) {
            Swal.fire(
                'Error!',
                'Please select at least one customer.',
                'error'
            );
            return;
        }

        await onSelectCustomer(selectedCustomers, formData);
    };
    useEffect(() => {
        if (customers && customers.length > 0) {
            const preSelected = customers.filter(
                c => c.FK_StockCategory_ID === CategoryID
            );

            setSelectedCustomers(preSelected);
        }
    }, [customers, CategoryID]);
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', "marginTop": "50px" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-header" onStart={handleStart}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Customer</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th className="no-wrap">
                                                Customer
                                            </th>

                                            <th className="no-wrap">Town/City</th>
                                            <th className="no-wrap">Post Code</th>
                                            <th className="no-wrap">Telephone</th>
                                            <th className="no-wrap">Customer Type</th>
                                            <th className="no-wrap">Account Status</th>
                                            <th className="no-wrap">Account Ref</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customers.map(customer => (
                                            <tr key={customer.ClientCompanyID} style={{ cursor: 'pointer' }}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCustomers.some(
                                                            c => c.ClientCompanyID === customer.ClientCompanyID
                                                        )}
                                                        onChange={() => handleCheckboxChange(customer)}
                                                    />
                                                </td>

                                                <td className="no-wrap">{truncateText(customer.CompanyName)}</td>

                                                <td className="no-wrap">{truncateText(customer.City)}</td>
                                                <td className="no-wrap">{truncateText(customer.Postcode)}</td>
                                                <td className="no-wrap">{truncateText(customer.Phone1)}</td>
                                                <td className="no-wrap">{truncateText(customer.FK_ClientCompanyType_ID)}</td>
                                                <td className="no-wrap">{truncateText(customer.vc_AccountStatus)}</td>
                                                <td className="no-wrap">{truncateText(customer.AccountRef)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                <i className="icofont-save" aria-hidden="true"> Save</i>
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                            </button>

                            
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerSelectionModal;
